import { render, staticRenderFns } from "./User.vue?vue&type=template&id=73c98afa&scoped=true"
import script from "./User.ts?vue&type=script&lang=ts&external"
export * from "./User.ts?vue&type=script&lang=ts&external"
import style0 from "./User.scss?vue&type=style&index=0&id=73c98afa&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c98afa",
  null
  
)

export default component.exports